module.exports = __webpack_public_path__ + "static/media/checkbox1.cc19bcb9.svg";